export type CurrencyCode = "EUR";

export const getPreferredCurrencyFromLanguage = (): CurrencyCode => "EUR";
